import React, { useEffect, memo } from 'react';
import { useSensorData } from '../../contexts/SensorDataContext';

interface WorkoutTypeSetterProps {
  workoutType: 'hangboard' | 'portable' | 'lift' | 'unknown';
  children: React.ReactNode;
}

const WorkoutTypeSetter: React.FC<WorkoutTypeSetterProps> = memo(({ workoutType, children }) => {
  const { setWorkoutType } = useSensorData();

  useEffect(() => {
    setWorkoutType(workoutType);
  }, [workoutType, setWorkoutType]);

  return <>{children}</>;
});

export default WorkoutTypeSetter;
